<script>
  import { createEventDispatcher, onDestroy, onMount } from "svelte";
  import { editor } from "../stores/editor.js";

  export let pagePromise;
  export let zoomLevel = 1.0;

  const dispatch = createEventDispatcher();

  let canvasElement;
  let nativeWidth = 0;
  let nativeHeight = 0;
  let scaledWidth = 0;
  let scaledHeight = 0;

  function measure() {
    if (!canvasElement || !nativeWidth) return;
    dispatch("measure", { scale: canvasElement.clientWidth / nativeWidth });
  }

  let renderTask = null;

  async function render() {
    const page = await pagePromise;
    if (!canvasElement) return;

    const originalViewport = page.getViewport({ scale: 1, rotation: 0 });
    nativeWidth = originalViewport.width;
    nativeHeight = originalViewport.height;

    const viewport = page.getViewport({
      scale: $editor.pdfRenderScale * zoomLevel,
      rotation: 0,
    });
    scaledWidth = viewport.width;
    scaledHeight = viewport.height;

    const context = canvasElement.getContext("2d");
    if (renderTask) {
      try {
        renderTask.cancel();
      } catch (e) {}
    }

    renderTask = page.render({ canvasContext: context, viewport });
    try {
      await renderTask.promise;
    } catch (err) {
      if (err.name === "RenderingCancelledException") return;
      // Removed console.error(err);
    }
    measure();
  }

  let lastPagePromise = null;
  let lastRenderScale = null;
  let lastZoomLevel = null;

  $: if (canvasElement && pagePromise) {
    if (
      pagePromise !== lastPagePromise ||
      $editor.pdfRenderScale !== lastRenderScale ||
      zoomLevel !== lastZoomLevel
    ) {
      lastPagePromise = pagePromise;
      lastRenderScale = $editor.pdfRenderScale;
      lastZoomLevel = zoomLevel;
      render();
    }
  }

  $: if (canvasElement && (nativeWidth || zoomLevel)) {
    requestAnimationFrame(measure);
  }

  onMount(() => {
    window.addEventListener("resize", measure);
  });
  onDestroy(() => window.removeEventListener("resize", measure));
</script>

<div>
  <canvas
    bind:this={canvasElement}
    style="max-width: none; width: {nativeWidth *
      zoomLevel}px; height: {nativeHeight * zoomLevel}px;"
    width={scaledWidth}
    height={scaledHeight}
  />
</div>
